import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type RefetchQueries} from 'web-app/util/graphql';
import {type ActivityFragment} from 'web-app/react/activities/__generated__/queries.api-types';

const domain = 'MODALS/ACTIVITY_FORM';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (
        show: boolean,
        activityId: string,
        refetchQueries: RefetchQueries | undefined,
        successAction: (activity: ActivityFragment) => void,
        institutionId: string,
        refetchQueriesOnDelete?: RefetchQueries,
    ) => ({show, activityId, refetchQueries, successAction, institutionId, refetchQueriesOnDelete}),
);
